import { createReducer } from 'redux-act';
import actions from '../actions/dashboardActions';

const initialState = {
  employeeRequestPendingPending: false,
  employeeRequestPendingRes: null,
  employeeRequestPendingError: null,

  employeeCorrectionCountPending: false,
  employeeCorrectionCountRes: null,
  employeeCorrectionCountError: null,

  employeeWeeklyAttendanceTrendPending: false,
  employeeWeeklyAttendanceTrendRes: null,
  employeeWeeklyAttendanceTrendError: null,

  employeeAttendanceStatisticsPending: false,
  employeeAttendanceStatisticsRes: null,
  employeeAttendanceStatisticsError: null,

  employeeLeavesStatisticsPending: false,
  employeeLeavesStatisticsRes: null,
  employeeLeavesStatisticsError: null,

  getAnnouncementCountPending: false,
  getAnnouncementCountRes: null,
  getAnnouncementCountError: null,

  employeeAttendanceCountPending: false,
  employeeAttendanceCountRes: null,
  employeeAttendanceCountError: null,

  employeeAttendancePending: false,
  employeeAttendanceRes: null,
  employeeAttendanceError: null,

  getEmployeeAttendanceStatusPending: false,
  getEmployeeAttendanceStatusRes: null,
  getEmployeeAttendanceStatusError: null,

  employeeLeaveOrTimeOffPending: false,
  employeeLeaveOrTimeOffRes: null,
  employeeLeaveOrTimeOffError: null,

  todayPresentEmployeeRequest: null,
  todayPresentEmployeeSuccess: null,
  todayPresentEmployeeError: null,

  moodMeterModal: null,
  pendingTaskModal: null,
  todayTaskModal: null,
  isShowAutoPopUp: true,
  announcementModal: null

};
/* Add Designation Reducers */
const handleEmployeeRequestPendingRequest = state => {
  return {
    ...state,
    ...{
      employeeRequestPendingPending: true,
      employeeRequestPendingRes: null,
      employeeRequestPendingError: null,
    },
  };
};
const handleEmployeeRequestPendingSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      employeeRequestPendingPending: false,
      employeeRequestPendingRes: payload,
      employeeRequestPendingError: null,
    },
  };
};
const handleEmployeeRequestPendingError = (state, payload) => ({
  ...state,
  ...{
    employeeRequestPendingPending: false,
    employeeRequestPendingRes: null,
    employeeRequestPendingError: payload,
  },
});


/* Get Designation Reducers */
const handleEmployeeCorrectionCountRequest = state1 => {
  return {
    ...state1,
    ...{
      employeeCorrectionCountPending: true,
      employeeCorrectionCountRes: null,
      employeeCorrectionCountError: null,
    },
  };
};
const handleEmployeeCorrectionCountSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      employeeCorrectionCountPending: false,
      employeeCorrectionCountRes: payload,
      employeeCorrectionCountError: null,
    },
  };
};
const handleEmployeeCorrectionCountError = (state1, payload) => ({
  ...state1,
  ...{
    employeeCorrectionCountPending: false,
    employeeCorrectionCountRes: null,
    employeeCorrectionCountError: payload,
  },
});


/* Get Designation by Department Reducers */
const handleEmployeeWeeklyAttendanceTrendRequest = state1 => {
  return {
    ...state1,
    ...{
      employeeWeeklyAttendanceTrendPending: true,
      employeeWeeklyAttendanceTrendRes: null,
      employeeWeeklyAttendanceTrendError: null,
    },
  };
};
const handleEmployeeWeeklyAttendanceTrendSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      employeeWeeklyAttendanceTrendPending: false,
      employeeWeeklyAttendanceTrendRes: payload,
      employeeWeeklyAttendanceTrendError: null,
    },
  };
};
const handleEmployeeWeeklyAttendanceTrendError = (state1, payload) => ({
  ...state1,
  ...{
    employeeWeeklyAttendanceTrendPending: false,
    employeeWeeklyAttendanceTrendRes: null,
    employeeWeeklyAttendanceTrendError: payload,
  },
});

/* Update Designation Reducers*/
const handleEmployeeAttendanceStatisticsRequest = state1 => {
  return {
    ...state1,
    ...{
      employeeAttendanceStatisticsPending: true,
      employeeAttendanceStatisticsRes: null,
      employeeAttendanceStatisticsError: null,
    },
  };
};
const handleEmployeeAttendanceStatisticsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      employeeAttendanceStatisticsPending: false,
      employeeAttendanceStatisticsRes: payload,
      employeeAttendanceStatisticsError: null,
    },
  };
};
const handleEmployeeAttendanceStatisticsError = (state1, payload) => ({
  ...state1,
  ...{
    employeeAttendanceStatisticsPending: false,
    employeeAttendanceStatisticsRes: null,
    employeeAttendanceStatisticsError: payload,
  },
});

/* Delete Designation Reducers*/
const handleEmployeeLeavesStatisticsRequest = state1 => {
  return {
    ...state1,
    ...{
      employeeLeavesStatisticsPending: true,
      employeeLeavesStatisticsRes: null,
      employeeLeavesStatisticsError: null,
    },
  };
};
const handleEmployeeLeavesStatisticsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      employeeLeavesStatisticsPending: false,
      employeeLeavesStatisticsRes: payload,
      employeeLeavesStatisticsError: null,
    },
  };
};
const handleEmployeeLeavesStatisticsError = (state1, payload) => ({
  ...state1,
  ...{
    employeeLeavesStatisticsPending: false,
    employeeLeavesStatisticsRes: null,
    employeeLeavesStatisticsError: payload,
  },
});

/* Get Announcement Count Reducers*/
const handleGetAnnouncementCountRequest = state1 => {
  return {
    ...state1,
    ...{
      getAnnouncementCountPending: true,
      getAnnouncementCountRes: null,
      getAnnouncementCountError: null,
    },
  };
};
const handleGetAnnouncementCountSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAnnouncementCountPending: false,
      getAnnouncementCountRes: payload,
      getAnnouncementCountError: null,
    },
  };
};
const handleGetAnnouncementCountError = (state1, payload) => ({
  ...state1,
  ...{
    getAnnouncementCountPending: false,
    getAnnouncementCountRes: null,
    getAnnouncementCountError: payload,
  },
});

/* employee Attendance Count Reducers*/
const handleEmployeeAttendanceCountRequest = state1 => {
  return {
    ...state1,
    ...{
      employeeAttendanceCountPending: true,
      employeeAttendanceCountRes: null,
      employeeAttendanceCountError: null,
    },
  };
};
const handleEmployeeAttendanceCountSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      employeeAttendanceCountPending: false,
      employeeAttendanceCountRes: payload,
      employeeAttendanceCountError: null,
    },
  };
};
const handleEmployeeAttendanceCountError = (state1, payload) => ({
  ...state1,
  ...{
    employeeAttendanceCountPending: false,
    employeeAttendanceCountRes: null,
    employeeAttendanceCountError: payload,
  },
});


/* employee Attendance  Reducers*/
const handleEmployeeAttendanceRequest = state1 => {
  return {
    ...state1,
    ...{
      employeeAttendancePending: true,
      employeeAttendanceRes: null,
      employeeAttendanceError: null,
    },
  };
};
const handleEmployeeAttendanceSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      employeeAttendancePending: false,
      employeeAttendanceRes: payload,
      employeeAttendanceError: null,
    },
  };
};
const handleEmployeeAttendanceError = (state1, payload) => ({
  ...state1,
  ...{
    employeeAttendancePending: false,
    employeeAttendanceRes: null,
    employeeAttendanceError: payload,
  },
});


/* employee Attendance  Reducers*/
const handleGetEmployeeAttendanceStatusRequest = state1 => {
  return {
    ...state1,
    ...{
      getEmployeeAttendanceStatusPending: true,
      getEmployeeAttendanceStatusRes: null,
      getEmployeeAttendanceStatusError: null,
    },
  };
};
const handleGetEmployeeAttendanceStatusSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEmployeeAttendanceStatusPending: false,
      getEmployeeAttendanceStatusRes: payload,
      getEmployeeAttendanceStatusError: null,
    },
  };
};
const handleGetEmployeeAttendanceStatusError = (state1, payload) => ({
  ...state1,
  ...{
    getEmployeeAttendanceStatusPending: false,
    getEmployeeAttendanceStatusRes: null,
    getEmployeeAttendanceStatusError: payload,
  },
});

/* employee Attendance  Reducers*/
const handleEmployeeLeaveOrTimeOffRequest = state1 => {
  return {
    ...state1,
    ...{
      employeeLeaveOrTimeOffPending: true,
      employeeLeaveOrTimeOffRes: null,
      employeeLeaveOrTimeOffError: null,
    },
  };
};
const handleEmployeeLeaveOrTimeOffSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      employeeLeaveOrTimeOffPending: false,
      employeeLeaveOrTimeOffRes: payload,
      employeeLeaveOrTimeOffError: null,
    },
  };
};
const handleEmployeeLeaveOrTimeOffError = (state1, payload) => ({
  ...state1,
  ...{
    employeeLeaveOrTimeOffPending: false,
    employeeLeaveOrTimeOffRes: null,
    employeeLeaveOrTimeOffError: payload,
  },
});


/* employee Attendance  Reducers*/
const handleTodayPresentEmployeeRequest = state1 => {
  return {
    ...state1,
    ...{
      todayPresentEmployeePending: true,
      todayPresentEmployeeRes: null,
      todayPresentEmployeeError: null,
    },
  };
};
const handleTodayPresentEmployeeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      todayPresentEmployeePending: false,
      todayPresentEmployeeRes: payload,
      todayPresentEmployeeError: null,
    },
  };
};
const handleTodayPresentEmployeeError = (state1, payload) => ({
  ...state1,
  ...{
    todayPresentEmployeePending: false,
    todayPresentEmployeeRes: null,
    todayPresentEmployeeError: payload,
  },
});



const handleMoodMeter = (state1, payload) => ({
  ...state1,
  ...{
    moodMeterModal: payload,
  },
});
const handlePendingTaskModal = (state1, payload) => ({
  ...state1,
  ...{
    pendingTaskModal: payload,
  },
});
const handleTodayTaskModal = (state1, payload) => ({
  ...state1,
  ...{
    todayTaskModal: payload,
  },
});
const handleIsShowAutoPopUp = (state1, payload) => ({
  ...state1,
  ...{
    isShowAutoPopUp: payload,
  },
});
const handleAnnouncementModal = (state1, payload) => ({
  ...state1,
  ...{
    announcementModal: payload,
  },
});
/* Clear Designation Store */
const clearDashboardStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_EMPLOYEE_REQUEST_PENDING_STORE':
      return {
        ...state,
        ...{
          employeeRequestPendingPending: false,
          employeeRequestPendingRes: null,
          employeeRequestPendingError: null,
        },
      };
    case 'HANDLE_CLEAR_EMPLOYEE_ATTENDANCE_STATISTICS_STORE':
      return {
        ...state,
        ...{
          employeeAttendanceStatisticsPending: false,
          employeeAttendanceStatisticsRes: null,
          employeeAttendanceStatisticsError: null,
        },
      };
    case 'HANDLE_CLEAR_EMPLOYEE_LEAVE_STATISTICS_STORE':
      return {
        ...state,
        ...{
          employeeLeavesStatisticsPending: false,
          employeeLeavesStatisticsRes: null,
          employeeLeavesStatisticsError: null,
        },
      };
    case 'HANDLE_CLEAR_ATTENDANCE_STATUS_REPORT_STORE':
      return {
        ...state,
        ...{
          getEmployeeAttendanceStatusPending: false,
          getEmployeeAttendanceStatusRes: null,
          getEmployeeAttendanceStatusError: null,
        },
      };
    case 'HANDLE_CLEAR_POPUP_STORE':
      return {
        ...state,
        ...{
          moodMeterModal: null,
          pendingTaskModal: null,
          todayTaskModal: null,
          announcementModal: null,
          isShowAutoPopUp: null
        },
      };

    // case 'HANDLE_MOOD_METER'
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.employeeRequestPendingRequest]: handleEmployeeRequestPendingRequest,
    [actions.employeeRequestPendingSuccess]: handleEmployeeRequestPendingSuccess,
    [actions.employeeRequestPendingError]: handleEmployeeRequestPendingError,

    [actions.employeeCorrectionCountRequest]: handleEmployeeCorrectionCountRequest,
    [actions.employeeCorrectionCountSuccess]: handleEmployeeCorrectionCountSuccess,
    [actions.employeeCorrectionCountError]: handleEmployeeCorrectionCountError,

    [actions.employeeWeeklyAttendanceTrendRequest]: handleEmployeeWeeklyAttendanceTrendRequest,
    [actions.employeeWeeklyAttendanceTrendSuccess]: handleEmployeeWeeklyAttendanceTrendSuccess,
    [actions.employeeWeeklyAttendanceTrendError]: handleEmployeeWeeklyAttendanceTrendError,

    [actions.employeeAttendanceStatisticsRequest]: handleEmployeeAttendanceStatisticsRequest,
    [actions.employeeAttendanceStatisticsSuccess]: handleEmployeeAttendanceStatisticsSuccess,
    [actions.employeeAttendanceStatisticsError]: handleEmployeeAttendanceStatisticsError,

    [actions.employeeLeavesStatisticsRequest]: handleEmployeeLeavesStatisticsRequest,
    [actions.employeeLeavesStatisticsSuccess]: handleEmployeeLeavesStatisticsSuccess,
    [actions.employeeLeavesStatisticsError]: handleEmployeeLeavesStatisticsError,

    [actions.getAnnouncementCountRequest]: handleGetAnnouncementCountRequest,
    [actions.getAnnouncementCountSuccess]: handleGetAnnouncementCountSuccess,
    [actions.getAnnouncementCountError]: handleGetAnnouncementCountError,

    [actions.employeeAttendanceCountRequest]: handleEmployeeAttendanceCountRequest,
    [actions.employeeAttendanceCountSuccess]: handleEmployeeAttendanceCountSuccess,
    [actions.employeeAttendanceCountError]: handleEmployeeAttendanceCountError,

    [actions.employeeAttendanceRequest]: handleEmployeeAttendanceRequest,
    [actions.employeeAttendanceSuccess]: handleEmployeeAttendanceSuccess,
    [actions.employeeAttendanceError]: handleEmployeeAttendanceError,

    [actions.getEmployeeAttendanceStatusRequest]: handleGetEmployeeAttendanceStatusRequest,
    [actions.getEmployeeAttendanceStatusSuccess]: handleGetEmployeeAttendanceStatusSuccess,
    [actions.getEmployeeAttendanceStatusError]: handleGetEmployeeAttendanceStatusError,

    [actions.employeeLeaveOrTimeOffRequest]: handleEmployeeLeaveOrTimeOffRequest,
    [actions.employeeLeaveOrTimeOffSuccess]: handleEmployeeLeaveOrTimeOffSuccess,
    [actions.employeeLeaveOrTimeOffError]: handleEmployeeLeaveOrTimeOffError,

    [actions.todayPresentEmployeeRequest]: handleTodayPresentEmployeeRequest,
    [actions.todayPresentEmployeeSuccess]: handleTodayPresentEmployeeSuccess,
    [actions.todayPresentEmployeeError]: handleTodayPresentEmployeeError,

    [actions.moodMeter]: handleMoodMeter,
    [actions.pendingTask]: handlePendingTaskModal,
    [actions.todayTask]: handleTodayTaskModal,
    [actions.isShowAutoPopUp]: handleIsShowAutoPopUp,
    [actions.announcementModal]: handleAnnouncementModal,
    [actions.handleClearDashboardStore]: clearDashboardStore,
  },
  initialState,
);